// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { useMutation } from "@apollo/client";
import {
  CAlert,
  CButton,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react-pro";
import Form, { useForm } from "rc-field-form";
import { useState } from "react";
import { FormField, Input } from "../../../../components/Form";
import { CREATE_ID_DEFINITION, UPDATE_ID_DEFINITION } from "../../../../graphql/queries/linked-id";

const DynamicLinkDefinitionModal = ({ initialValues, onComplete = () => void 0 }) => {
  const [open, setOpen] = useState(false);
  const [form] = useForm();
  const [error, setError] = useState("");

  const title =
    initialValues && initialValues.id ? "Update Link Definition" : "Create Link Definition";

  const [create, { loading }] = useMutation(CREATE_ID_DEFINITION);

  const [update, { loading: updateLoading }] = useMutation(UPDATE_ID_DEFINITION);

  const handleSave = (variables) => {
    setError("");
    if (initialValues && initialValues.id) {
      update({ variables: { ...initialValues, ...variables } })
        .then(() => {
          onComplete();
          setOpen(false);
          form.resetFields();
        })
        .catch((e) => {
          setError(e.message);
        });
    } else {
      create({ variables })
        .then(() => {
          onComplete();
          setOpen(false);
          form.resetFields();
        })
        .catch((e) => {
          setError(e.message);
        });
    }
  };
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <>
      <CModal
        visible={open}
        onClose={() => {
          handleCancel();
        }}
      >
        <CModalHeader>
          <CModalTitle>{title}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Form form={form} onFinish={handleSave} initialValues={initialValues ?? {}}>
            <FormField
              horizontal
              name={"name"}
              label={"ID Name"}
              rules={[{ required: true, message: "You must enter a name." }]}
            >
              <Input />
            </FormField>
            <FormField horizontal name={"description"} label={"A short description"}>
              <Input />
            </FormField>
            <FormField
              horizontal
              name={"slug"}
              label={"ID Tag. This will be generated from the name if not entered."}
            >
              <Input />
            </FormField>
          </Form>
          {error && <CAlert color={"warning"}>{error}</CAlert>}
        </CModalBody>
        <CModalFooter>
          <CLoadingButton color={"primary"} loading={loading} onClick={() => form.submit()}>
            Save
          </CLoadingButton>
          <CButton onCLick={() => handleCancel()}>Cancel</CButton>
        </CModalFooter>
      </CModal>

      <CButton color={"primary"} onClick={() => setOpen(true)}>
        {title}
      </CButton>
    </>
  );
};

export default DynamicLinkDefinitionModal;
